<template>
  <div class="d-flex flex-column h-100">
    <div class="flex-shrink-0">
      <b-navbar toggleable="lg" type="dark" variant="success">
        <b-navbar-brand :to="{ name: 'AppStart' }">N2ushoorn</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav v-if="clientSiteEnabled">
            <b-nav-item active-class="active" :to="{ name: 'ClientOverviewActivities' }">Mijn Activiteiten</b-nav-item>
            <b-nav-item exact-active-class="active" :to="{ name: 'ClientOverviewActivityTypes' }">Activiteitstypes</b-nav-item>
            <b-nav-item active-class="active" :to="{ name: 'ClientOverviewProfile' }">Mijn Opdrachtgevers Profiel</b-nav-item>
          </b-navbar-nav>

          <UserNavbar></UserNavbar>
        </b-collapse>
      </b-navbar>

      <router-view v-if="clientSiteEnabled" class="body-style"/>
      <b-container v-else class="mt-2">
        <b-jumbotron>
          <h6>De <code>Opdrachtgevers</code> app is op dit moment uitgeschakeld...</h6>
          <hr/>
          <p>
            De systeembeheerders hebben de Opdrachtgeversapp in N2ushoorn uitgeschakeld.

            <br>

            <small class="text-muted">De N2ushoorn app kan weer worden ingeschakeld door <code>client_app_enabled</code> in te schakelen in de systeeminstellingen.</small>
          </p>
        </b-jumbotron>
      </b-container>
    </div>
    <n2ushoornFooter
        :contact-info-ready="contactInfoReady"
        :public-contact-and-location-information="publicContactAndLocationInformation"
    />
  </div>
</template>

<script>
import UserNavbar from "@/components/UserNavbar";
import n2ushoornFooter from "@/components/n2ushoornFooter";

export default {
  name: "ClientBase",
  components: {
    UserNavbar,
    n2ushoornFooter
  },
  props: {
    publicContactAndLocationInformation: Object,
    statusInformation: Object,
    contactInfoReady: Boolean
  },
  computed: {
    clientSiteEnabled() {
      return this.statusInformation === null ? false : this.statusInformation.client_app_enabled;
    },
  }
}
</script>

<style scoped>
.body-style {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>